const cookieConsent = { push: {} };
cookieConsent.push['event'] = 'cookie_consent';

window.cookieConsent = cookieConsent;
// Push first cookies if not set
if ($.cookie('cookies_consent_set')) {
    for (var prop in App.Variable('CookiesConsent')) {
        cookieConsent.push[prop] = $.cookie(prop);
    }
    dataLayer.push(cookieConsent.push);
}
